import React, { useState, useEffect } from 'react';

export default function LMNotifications(props) {
    return <div>Notifications</div>;
}
